import React from 'react';
import {connect} from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import { Link } from 'react-router-dom'
import ConsoleDetect from '../components/ConsoleDetect'
import * as constants from '../constants';
import { loadTranslations } from '../utils/translations'

class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      lang: localStorage.getItem('lang')
    }
  }

  changeLanguage(e) {
    this.props.setLang(e.target.value)
  }

  render() {
    const currentPath = this.props.location.pathname
    let strings = loadTranslations(this.state.lang)
    return (
      <nav className="navbar navbar-default" style={{
        borderRadius: '0px',
        zIndex: 10000
      }}>
        <div style={{height: '50px'}}>

          {/* HEADER */}
          <div className="navbar-header">

            <button style={{display: 'none'}} type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse">
              <span className="sr-only">{strings.toggleNavigation}</span>
            </button>

            <div className="navbar-brand" style={{paddingTop: '0', paddingBottom: '0', paddingLeft: '0px', lineHeight: '49px'}}>
              <span>
                  <img style={{width: '40px', height: '40px'}} src='../../imgs/hse-cs-logo.png'/>
              </span> 
              &nbsp;
              <Link to={constants.PATH_ROOT}  style={{ textDecoration: 'none' }}>
                <span style={{display: 'inline-block', verticalAlign: 'text-top', lineHeight: '22px'}}>{strings.ethernaut}</span>
              </Link>
            </div>

          </div>

          {/* CONTENT */}
          <div className="navbar-collapse collapse" style={{display: 'block', height: '50px'}}>

            {/* LEFT */}
            <ul className="nav navbar-nav" style={{paddingLeft: '10px'}}>
              <li className={currentPath === constants.PATH_ROOT ? 'active' : ''}>
                <Link to={constants.PATH_ROOT} style={{fontSize: '16px'}}>{strings.home}</Link>
              </li>
              <li className={currentPath === constants.PATH_HELP ? 'active' : ''}>
                <Link to={constants.PATH_HELP} style={{fontSize: '16px'}}>{strings.help}</Link>
              </li>
              <li className={currentPath === constants.PATH_SCOREBOARD ? 'active' : ''}>
                <Link to={constants.PATH_SCOREBOARD} style={{fontSize: '16px'}}>Scoreboard</Link>
              </li>
              {/* <li className={currentPath === constants.PATH_STATS ? 'active' : ''}>
                <Link to={constants.PATH_STATS} style={{fontSize: '16px'}}>{strings.stats}</Link>
              </li> */}
            </ul>

            {/* RIGHT */}
            <ul className="nav navbar-nav pull-right" style={{float: 'right'}}>
            <li>
              <ConsoleDetect/>
            </li>
            {/* VERSIONS */}
            { constants.SHOW_VERSION &&
                <li>
                <span style={{fontSize: '12px'}}>
                  {`v${constants.VERSION}`}
                </span>
                </li>
            }


            </ul>
          </div>
        </div>

      </nav>
    );
  }
}


function mapStateToProps(state) {
  return { allLevelsCompleted: state.player.allLevelsCompleted }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setLang: actions.setLang
  }, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
